(function() {
  function init() {
    var btn = document.querySelector('.back-to-top-btn');
    if (!btn) return;

    var SHOW_AT = 600; // px scrolled before button appears
    var lastVisible = null;

    function setVisible(v) {
      if (v === lastVisible) return;
      lastVisible = v;
      if (v) {
        btn.style.opacity = '1';
        btn.style.pointerEvents = 'auto';
        btn.style.transform = 'translateY(0)';
      } else {
        btn.style.opacity = '0';
        btn.style.pointerEvents = 'none';
        btn.style.transform = 'translateY(12px)';
      }
    }

    function check() {
      setVisible(window.scrollY > SHOW_AT);
    }

    var ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function() { check(); ticking = false; });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // rAF poll as backup (e.g. when scroll events misfire)
    function tick() {
      check();
      window.requestAnimationFrame(tick);
    }
    window.requestAnimationFrame(tick);

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      try {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (err) {
        window.scrollTo(0, 0);
      }
    });

    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
